import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Briefcase, UserCheck, Target } from 'lucide-react';

const audiences = [
  {
    icon: Users,
    get title() { return translateInterfaceText("Influenciadores e Educadores"); },
    get description() { return translateInterfaceText("Microguru e Tutor"); }
  },
  {
    icon: Briefcase,
    get title() { return translateInterfaceText("Agências de Marketing"); },
    get description() { return translateInterfaceText("e Parceiros"); }
  },
  {
    icon: UserCheck,
    get title() { return translateInterfaceText("Consultores de Vendas"); },
    get description() { return translateInterfaceText("e Negócios"); }
  },
  {
    icon: Target,
    get title() { return translateInterfaceText("Freelancers e Profissionais"); },
    get description() { return translateInterfaceText("de Conteúdo"); }
  }
];

export function ReferralAudience() {
  useLanguage();
  return (
    <section className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-xl lg:text-2xl font-bold text-foreground">
          {translateInterfaceText("Quem Pode Ser Parceiro")}</h3>
        <p className="text-muted-foreground">
          {translateInterfaceText("Perfis ideais para o programa de parcerias")}</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {audiences.map((audience) => (
          <Card key={audience.title} className="text-center">
            <CardHeader>
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mx-auto mb-2">
                <audience.icon className="w-6 h-6 text-primary" />
              </div>
              <CardTitle className="text-base">{audience.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {audience.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
